<template>
    <div class="Header">
        <div :class="{'a': !isOpen, 'b': this.isWait}" class="burger-modal">
            <div class="burger-close">
                <div class="close" @click="toggleMenu">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <br>
            <center>
                <center><router-link aria-label="" to="/"><img alt="" class="logo width" src="@/assets/Logo-InterSeguros-h-White.png" /></router-link></center>
                <ul class="menu-burger" :style="{'height': windowHeight}">
                    <router-link aria-label="" class="inburger" to="/">{{$t('header.inicio')}}</router-link>
                    <router-link aria-label="" class="inburger" to="/empresa">{{$t('header.empresa')}}</router-link>
                    <router-link aria-label="" class="inburger" to="/aliado">{{$t('header.aliado')}}</router-link>
                        <router-link aria-label="" class="inburger" to="" @click.native="changeBlock">{{$t('header.servicios')}}
                            <ul class="submenu-burger" :class="{'block': block}">
                                <router-link aria-label="" class="inburger" to="/servicios/arl">{{$t('header.arl')}}</router-link>
                                <router-link aria-label="" class="inburger" to="/servicios/empresas">{{$t('header.empresas')}}</router-link>
                                <router-link aria-label="" class="inburger" to="/servicios/personas">{{$t('header.personas')}}</router-link>
                            </ul>
                        </router-link>
                    <router-link aria-label="" class="inburger" to="/blog">{{$t('header.blog')}}</router-link>
                    <router-link aria-label="" class="inburger" :to="to" @click.native="toTop">{{$t('header.contacto')}}</router-link>
                </ul>
            </center>
        </div>
        <div class="social-media">
            <div class="social-media-image">
                <div><a href="https://www.facebook.com/InterSegurosla"><img src="@/assets/facebook-top.png" alt="" srcset=""></a></div>
                <div><a href="https://www.instagram.com/intersegurosla/"><img src="@/assets/instagram-top.png" alt="" srcset=""></a></div>
                <div><a href="https://www.linkedin.com/company/intersegurosla/"><img src="@/assets/linkedin-top.png" alt="" srcset=""></a></div>
                <div><a href="https://twitter.com/InterSegurosla"><img src="@/assets/twitter-green.png" alt="" srcset=""></a></div>
            </div>
        </div>
        <div class="menu-container d-flex" :class="{'flex-effect': isScroll, 'add-flex-effect': waitScroll, 'remove-flex-effect': !waitScroll}" v-if="!burger">
            <div class="routes">
                <router-link aria-label="" to="/"><img alt="" class="logo" src="@/assets/logo/Logo-interSeguros-h.webp" /></router-link>
                <router-link class="menu" aria-label="" to="/">{{$t('header.inicio')}}</router-link>
                <router-link class="menu" aria-label="" to="/empresa">{{$t('header.empresa')}}</router-link>
                <router-link class="menu" aria-label="" to="/aliado">{{$t('header.aliado')}}</router-link>
                <router-link aria-label="" class="menu hover" to="/servicios">{{$t('header.servicios')}}
                     <ul class="submenu">
                        <router-link aria-label="" class="inburger" to="/servicios/arl">{{$t('header.arl')}}</router-link>
                        <router-link aria-label="" class="inburger" to="/servicios/empresas">{{$t('header.empresas')}}</router-link>
                        <router-link aria-label="" class="inburger" to="/servicios/personas">{{$t('header.personas')}}</router-link>
                    </ul>
                </router-link>
                <a aria-label="" class="menu" href="https://blog.grupogeos.co/" target="_blank">{{$t('header.blog')}}</a>
                <router-link class="menu" aria-label="" :to="to" @click.native="toTop">{{$t('header.contacto')}}</router-link>
                <button class="button" v-if="noHomeStatus" @click="open">{{$t('header.button')}}</button>
            </div>
        </div>
        <div v-if="burger && !isOpen && !isWait" class="burger-menu" @click="toggleMenu">
            <img alt="" id="burger-img" src="@/assets/icon-burger.png">
        </div>
    </div>
</template>

<script>

export default {
    name: 'Header',
    props: {
        name: String
    },
    data() {
        return {
            burger: false,
            windowHeight: window.innerHeight + 'px',
            showBackdrop: true,
            closeOnDocumentClick: true,
            isOpen: false,
            isWait: false,
            noHomeStatus: false,
            isScroll: false,
            waitScroll: false,
            isTop: false,
            to: '',
            block: false
        }
    },
    beforeMount() {
        if (this.$route.name === 'ARL') {
            this.noHomeStatus = true
        } else {
            this.noHomeStatus = false
        }
    },
    mounted() {
        this.windowHeight = (window.innerHeight - 150) + 'px'
        if (window.innerWidth < 1016) {
            this.burger = true
        } else {
            this.burger = false
        }
        this.$root.$on('change_url', (block) => {
            if (this.$route.name === 'ARL') {
                this.noHomeStatus = true
            } else {
                this.noHomeStatus = false
            }
        })
    },
    created() {
        window.addEventListener('resize', this.myEventHandler)
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed() {
        window.removeEventListener('resize', this.myEventHandler)
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        changeBlock() {
            this.block = !this.block
        },
        open() {
            window.open('http://interlaborales.nygsst.com/', '_blank')
        },
        toTop() {
            window.scrollTo(0, document.body.scrollHeight)
        },
        myEventHandler(e) {
            this.windowHeight = (window.innerHeight - 150) + 'px'
            if (window.innerWidth < 1016) {
                this.burger = true
            } else {
                this.burger = false
                this.isOpen = false
                this.isWait = false
            }
        },
        toggleMenu() {
            this.isWait = !this.isWait
            if (!this.isOpen)setTimeout(this.change, 900)
            else {
                this.change()
                this.block = false
            }
        },
        change() {
            this.isOpen = !this.isOpen
        },
        handleScroll(e) {
            if (window.scrollY > 0) {
                this.isScroll = true
                this.isTop = false
                setTimeout(() => { this.changeScrollTOP(true) }, 450)
            } else {
                this.isScroll = false
                this.waitScroll = false
                this.isTop = true
            }
            if (window.scrollY > 2200) {
                this.$root.$emit('Header')
            }
        },
        changeScrollTOP(scroll) {
            if (!this.isTop) {
                this.waitScroll = scroll
            }
        }
    }
}
</script>

<style scoped>
    .submenu-burger {
        background-color: rgba(45,79,152,0.6);
        position: absolute;
        display: none;
        margin-left: 245px;
        padding: 0px 40px 20px 40px;
        margin-top: -75px;
        color: #fff;
    }
    .block {
        display: grid;
    }
    .submenu {
        background-color: rgba(45,79,152,0.6);
        display: none;
        position: absolute;
        padding: 0px 40px 20px 40px;
        margin-top: 15px;
        margin-left: -40px;
        color: #fff;
    }
    .submenu > a {
        color: #fff;
    }
    .hover:hover .submenu {
        display: grid;
    }
    .logo {
        width: 170px;
        margin: 0px 70px 0px 0px;
    }
    .width {
        width: 100%;
    }
    .social-media {
        width: 100%;
        height: 50px;
        background-color: #2d4f98;
        padding-top: 10px;
    }
    .social-media-image {
        width: 120px;
        display: inline-flex;
        float: right;
        margin-right: 150px;
    }
    .social-media-image > div > a > img:hover{
        width: 35px;
    }
    .menu-container {
        width: 100%;
        background: aliceblue;
        height: 70px;
        position: relative;
        z-index: 99999999;
    }
    .add-flex-effect {
        margin-top: -50px;
    }
    .remove-flex-effect {
        margin-top: 0px;
    }
    .flex-effect{
        position: fixed;
        -webkit-animation: headerEffect 0.5s; /* Chrome, Safari, Opera */
        animation: headerEffect 0.5s;
    }
    @-webkit-keyframes headerEffect {
        0% {margin-top: -120px;}
        20% {margin-top: -105px;}
        40% {margin-top: -90px;}
        60% {margin-top: -75px;}
        80% {margin-top: -60px;}
        100% {margin-top: -50px;}
    }
    /* Standard syntax */
    @keyframes headerEffect {
        0% {margin-top: -120px;}
        20% {margin-top: -105px;}
        40% {margin-top: -90px;}
        60% {margin-top: -75px;}
        80% {margin-top: -60px;}
        100% {margin-top: -50px;}
    }
    .routes {
        display: flex;
        align-items: center;
        margin: 0 auto;
        white-space: nowrap;
    }
    .menu{
        padding: 15px;
        font-family: 'JBD';
        font-size: 15px;
        color: #2d4f98;
        display: block
    }
    .menu:hover {
        color: #65b24a;
        text-decoration: none;
    }
    .menu.active {
        color: #65b24a;
        text-decoration: none;
    }
    .burger-menu {
        height: auto;
        padding: 10px;
        position: fixed;
        z-index: 999999;
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 50%;
        margin: 10px;
    }
    .burger-modal{
        width: 250px;
        height: 100%;
        position: fixed;
        background-color: rgba(45,79,152, 0.8);
        border-style: solid;
        border-color: #2d4f98;
        z-index: 9999999999999999999;
    }
    .menu-burger > a {
        color: #fff
    }
    .a{
        margin-left: -250px;
    }
    .b{
        -webkit-animation: test 1s; /* Chrome, Safari, Opera */
        animation: test 1s;
    }
/* Chrome, Safari, Opera */
    @-webkit-keyframes test {
        100% {margin-left: 0px;}
    }
    /* Standard syntax */
    @keyframes test {
        100% {margin-left: 0px;}
    }
    .menu-burger{
        display: inline-grid;
        overflow-y: auto;
        padding: 20px 0px 20px 0px;
        width: 100%;
    }
    .menu-burger::-webkit-scrollbar {
        display: none;
    }
    .inburger {
        padding-top: 25px;
        width: 100%;
        color: #fff;
    }
    .burger-close {
        position: absolute;
        right: 10px;
        top: 5px;
    }
    .button {
        font-family: 'JR';
        background-color: #65b24a;
        width: 240px;
        height: 40px;
        border-radius: 20px;
        border-color: #65b24a;
        border-style: solid;
        font-size: 15px;
        color: #fff;
        margin-left: 6%;
    }
    .button:hover {
        background-color: #2d4f98;
        border-color: #2d4f98;
    }
    @media (max-width: 400px) {
        .menu-container{
            position: fixed;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue